/**
 * Parsed `NotificationDto.payload` shape for `type === 'ContactImportCompletedNotification'`.
 * Backend may serialize as PascalCase — both casings are accepted defensively.
 *
 * Only the summary counters travel in the payload; the per-row detail is fetched on demand from
 * `ContactImportService.getImportResult(importId)` when the row's "View" action is used.
 */
export interface ContactImportNotificationPayload {
  importId?: string;
  ImportId?: string;
  fileName?: string;
  FileName?: string;
  totalRows?: number;
  TotalRows?: number;
  successCount?: number;
  SuccessCount?: number;
  failedCount?: number;
  FailedCount?: number;
  skippedForUnknownSegmentCount?: number;
  SkippedForUnknownSegmentCount?: number;
  isFailed?: boolean;
  IsFailed?: boolean;
  hasStoredResult?: boolean;
  HasStoredResult?: boolean;
}

/** Casing-tolerant view of a raw contact-import payload. */
export interface NormalizedContactImportPayload {
  importId: string | null;
  fileName: string;
  totalRows: number;
  successCount: number;
  failedCount: number;
  skippedForUnknownSegmentCount: number;
  isFailed: boolean;
  hasStoredResult: boolean;
}

/** Normalizes a parsed payload so callers never have to repeat the camelCase/PascalCase fallbacks. */
export function normalizeContactImportPayload(
  parsed: ContactImportNotificationPayload | null,
): NormalizedContactImportPayload {
  return {
    importId: parsed?.importId ?? parsed?.ImportId ?? null,
    fileName: parsed?.fileName ?? parsed?.FileName ?? '',
    totalRows: parsed?.totalRows ?? parsed?.TotalRows ?? 0,
    successCount: parsed?.successCount ?? parsed?.SuccessCount ?? 0,
    failedCount: parsed?.failedCount ?? parsed?.FailedCount ?? 0,
    skippedForUnknownSegmentCount:
      parsed?.skippedForUnknownSegmentCount ?? parsed?.SkippedForUnknownSegmentCount ?? 0,
    isFailed: parsed?.isFailed ?? parsed?.IsFailed ?? false,
    // Absent in payloads written before the flag existed — those always had a stored result.
    hasStoredResult: parsed?.hasStoredResult ?? parsed?.HasStoredResult ?? true,
  };
}
